import React, { useRef, useEffect } from "react";
import ScrollAni from "../components/ScrollAni";

const SubKV = (props) => {

  const subkvDesc = useRef();
  const subkvTitle = useRef();

  const observer = useRef(
    new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('on');
          } else {
            entry.target.classList.remove('on');
          }
        });
      },
      { threshold: 0.1 }
    )
  );

  useEffect(() => {
    observer.current.observe(subkvDesc.current);
    observer.current.observe(subkvTitle.current);
  }, []);



  return (
    <section id="SUBKV">
      <div className="subkv__inner">

        <div className="subkv__img">
          <picture>
            <source media="(min-width: 1024px)" srcSet={props.img.pcSrc} />
            <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={props.img.tabSrc} />
            <source media="(min-width: 0px) and (max-width: 767px)" srcSet={props.img.moSrc} />
            <img src={props.img.pcSrc} alt={props.img.alt} />
          </picture>
        </div>

        <div className="subkv__title__wrap">
          <p className="subkv__desc" ref={subkvDesc}>스타 법무법인 <strong>대전분사무소</strong></p>

          <h1 className={`subkv__title ${props.class}`} ref={subkvTitle}>
            <picture>
              <source media="(min-width: 1024px)" srcSet={props.title.pcSrc} />
              <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={props.title.tabSrc} />
              <source media="(min-width: 0px) and (max-width: 767px)" srcSet={props.title.moSrc} />
              <img src={props.title.pcSrc} alt={props.title.alt} />
            </picture>
          </h1>
        </div>
      </div>
      <ScrollAni />
    </section>
  )
};

export default SubKV;